import React from 'react';
import AiToolWrapper from '../components/AiToolWrapper';
import { Link } from 'react-router-dom';
import './RemoveBgPage.css'; // ★ Separated CSS

// --- 1. SIDEBAR CONTENT COMPONENT ---
// This is injected into the AiToolWrapper sidebar
const ToolDescription = () => (
  <div className="tool-sidebar-content">
    <div className="tool-use-cases">
      <h4>Best For:</h4>
      <ul>
        <li>
          <i className="bi bi-bag-check-fill"></i>
          <span>E-commerce products</span>
        </li>
        <li>
          <i className="bi bi-megaphone-fill"></i>
          <span>Marketing assets</span>
        </li>
        <li>
          <i className="bi bi-person-bounding-box"></i>
          <span>Personal portraits</span>
        </li>
      </ul>
    </div>
    
    <div className="tool-trust-badge">
        <i className="bi bi-shield-lock"></i>
        <span>Images deleted after 24h</span>
    </div>
  </div>
);

const RemoveBgPage = ({ session }) => {
  
  // SEO Schema for Google
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "FullMockup Background Remover",
    "applicationCategory": "DesignApplication",
    "operatingSystem": "Web Browser",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    }
  };

  return (
    <div className="remove-bg-page fade-in">
      {/* Inject SEO Schema */}
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>

      {/* --- A. HEADER --- */}
      <header className="tool-page-header">
        <h1>Remove Backgrounds Instantly</h1>
        <p>Create professional transparent cutouts for your products, marketing materials, and designs in seconds.</p>
      </header>

      {/* --- B. WORKSPACE (The Tool) --- */}
      <div className="tool-workspace-container">
        <AiToolWrapper 
          title="Free Background Remover"
          apiEndpoint="/api/tools/remove-bg-fast"
          SettingsFormComponent={ToolDescription}
          session={session}
          actionName="Remove Background"
          layoutVariant="slider" // Enables Before/After Slider Mode
        />
      </div>

      {/* --- C. SEO & FAQ SECTION --- */}
      <section className="tool-seo-section">
        <div className="seo-content-block">
          <h2>What is FullMockup's Remove BG Tool?</h2>
          <p>
            Our AI-powered engine automatically detects the subject in your photo—whether it's a person, car, or product—and separates it from the background with pixel-perfect precision. It handles complex edges like hair and fur without needing Photoshop.
          </p>
        </div>

        <div className="tool-faq-grid">
          <div className="faq-card">
            <div className="icon-box"><i className="bi bi-cash-coin"></i></div>
            <h3>Is it free?</h3>
            <p>Yes. Free users get 10 generations per day. Upgrade to Pro for unlimited HD downloads.</p>
          </div>
          
          <div className="faq-card">
            <div className="icon-box"><i className="bi bi-file-earmark-image"></i></div>
            <h3>What formats?</h3>
            <p>We accept JPG, PNG, and WebP. The result is always a high-quality transparent PNG.</p>
          </div>

          <div className="faq-card">
            <div className="icon-box"><i className="bi bi-shield-check"></i></div>
            <h3>Is it private?</h3>
            <p>100%. We use a "Ghostbuster" protocol. Images are processed securely and deleted after 24 hours.</p>
          </div>
        </div>
      </section>

    </div>
  );
};

export default RemoveBgPage;